interface Section {
  heading: string;
  paragraphs?: string[];
  list?: string[];
}

const sections: Section[] = [
  {
    heading: "第1条(適用)",
    paragraphs: [
      "本利用規約(以下「本規約」といいます)は、株式会社ナンバ(以下「当社」といいます)が提供する人材みえる化ソリューションおよび本ウェブサイト(以下「本サービス」といいます)の利用条件を定めるものです。ご利用者(以下「利用者」といいます)は、本規約に同意の上、本サービスをご利用いただくものとします。",
    ],
  },
  {
    heading: "第2条(定義)",
    paragraphs: ["本規約において使用する用語の定義は、以下のとおりとします。"],
    list: [
      "「本サービス」とは、当社が提供する人材みえる化ソリューションおよびこれに付随するサービスをいいます。",
      "「利用者」とは、本規約に同意し、本サービスを利用するすべての方をいいます。",
      "「アカウント」とは、本サービスを利用するために利用者に付与されるIDおよびパスワード等の情報をいいます。",
      "「利用契約」とは、本規約に基づき、当社と利用者との間に成立する本サービスの利用に関する契約をいいます。",
    ],
  },
  {
    heading: "第3条(利用登録)",
    paragraphs: [
      "利用者は、当社所定の方法により利用登録を申請するものとします。当社は、申請内容を審査し、利用登録を承認する場合があります。次のいずれかに該当する場合、当社は利用登録を承認しないことがあります。",
    ],
    list: [
      "申請内容に虚偽の情報が含まれていた場合",
      "過去に本規約に違反したことがある場合",
      "その他、当社が利用登録を相当でないと判断した場合",
    ],
  },
  {
    heading: "第4条(アカウントの管理)",
    paragraphs: [
      "利用者は、自らの責任においてアカウントを適切に管理するものとします。アカウントを第三者に譲渡、貸与、または共有することはできません。",
      "アカウントの管理不十分、使用上の過誤、第三者の使用等によって生じた損害の責任は利用者が負うものとし、当社は一切の責任を負いません。",
    ],
  },
  {
    heading: "第5条(利用料金および支払方法)",
    paragraphs: [
      "利用者は、本サービスの有償部分の利用について、当社が別途定める利用料金を、当社が指定する方法により支払うものとします。",
      "利用者が利用料金の支払を遅滞した場合、当社が別途定める割合による遅延損害金を支払うものとします。",
    ],
  },
  {
    heading: "第6条(禁止事項)",
    paragraphs: ["利用者は、本サービスの利用にあたり、以下の行為をしてはなりません。"],
    list: [
      "法令または公序良俗に違反する行為",
      "犯罪行為に関連する行為",
      "当社または第三者の知的財産権、肖像権、プライバシー等を侵害する行為",
      "本サービスの運営を妨害するおそれのある行為",
      "不正アクセスをし、またはこれを試みる行為",
      "他の利用者または第三者に成りすます行為",
      "本サービスを通じて得た情報を不正に利用する行為",
      "その他、当社が不適切と判断する行為",
    ],
  },
  {
    heading: "第7条(本サービスの提供の停止等)",
    paragraphs: [
      "当社は、以下のいずれかの事由があると判断した場合、利用者に事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。",
    ],
    list: [
      "本サービスにかかるシステムの保守点検または更新を行う場合",
      "地震、落雷、火災、停電、天災などの不可抗力により本サービスの提供が困難となった場合",
      "その他、当社が本サービスの提供が困難と判断した場合",
    ],
  },
  {
    heading: "第8条(著作権および知的財産権)",
    paragraphs: [
      "本サービスによって提供されるコンテンツ(文章、画像、プログラム等を含みます)に関する著作権その他の知的財産権は、当社または正当な権利を有する第三者に帰属します。",
      "利用者は、これらの情報を、本サービスの利用の範囲を超えて複製、転載、改変、公衆送信等してはならないものとします。",
    ],
  },
  {
    heading: "第9条(秘密保持)",
    paragraphs: [
      "利用者は、本サービスの利用に関連して当社から開示された技術上、営業上その他一切の情報(以下「秘密情報」といいます)を、当社の事前の書面による承諾なく第三者に開示または漏洩してはなりません。ただし、次のいずれかに該当する情報は秘密情報に含まれないものとします。",
    ],
    list: [
      "開示を受けた時点で既に公知であった情報",
      "開示を受けた後、利用者の責めに帰すべき事由によらず公知となった情報",
      "正当な権限を有する第三者から秘密保持義務を負うことなく取得した情報",
      "秘密情報によることなく独自に開発した情報",
    ],
  },
  {
    heading: "第10条(反社会的勢力の排除)",
    paragraphs: [
      "当社および利用者は、現在も将来にわたっても、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロまたは特殊知能暴力集団等、その他これらに準ずる者(以下「反社会的勢力」といいます)に該当しないこと、および次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを確約するものとします。",
    ],
    list: [
      "反社会的勢力が経営を支配していると認められる関係を有すること",
      "反社会的勢力が経営に実質的に関与していると認められる関係を有すること",
      "自己、自社もしくは第三者の不正の利益を図る目的または第三者に損害を加える目的をもってするなど、不当に反社会的勢力を利用していると認められる関係を有すること",
      "反社会的勢力に対して資金等を提供し、または便宜を供与するなどの関与をしていると認められる関係を有すること",
      "役員または経営に実質的に関与している者が、反社会的勢力と社会的に非難されるべき関係を有すること",
    ],
  },
  {
    heading: "第11条(保証の否認および免責事項)",
    paragraphs: [
      "当社は、本サービスに事実上または法律上の瑕疵がないことを明示的にも黙示的にも保証しておりません。",
      "当社は、本サービスに起因して利用者に生じたあらゆる損害について、当社の故意または重過失による場合を除き、一切の責任を負いません。",
    ],
  },
  {
    heading: "第12条(損害賠償)",
    paragraphs: [
      "利用者が本規約に違反したことにより当社に損害を与えた場合、利用者は当社に対し、その損害(弁護士費用を含みます)を賠償するものとします。",
      "当社の責めに帰すべき事由により利用者に損害が生じた場合、当社は、通常生じ得る直接の損害の範囲に限り、これを賠償するものとします。",
      "当社が利用者に対して負う損害賠償責任の額は、利用者が当社に支払った直近1年分の利用料金の額を上限とします。",
    ],
  },
  {
    heading: "第13条(サービス内容の変更・終了)",
    paragraphs: [
      "当社は、利用者への事前の通知により、本サービスの内容を変更し、または本サービスの提供を終了することができるものとします。",
      "本サービスの提供を終了する場合、当社は、終了予定日の相当な期間前に利用者に通知するよう努めるものとします。",
      "当社は、本条に基づく本サービスの変更または終了により利用者に生じた損害について、一切の責任を負いません。",
    ],
  },
  {
    heading: "第14条(権利義務の譲渡の禁止)",
    paragraphs: [
      "利用者は、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を、第三者に譲渡し、移転し、担保に供し、または承継させることはできません。",
    ],
  },
  {
    heading: "第15条(本規約の変更)",
    paragraphs: [
      "当社は、必要と判断した場合には、利用者に通知を要することなく、いつでも本規約を変更することができるものとします。変更後の本規約は、当社がウェブサイト上に掲載した時点から効力を生じるものとします。",
    ],
  },
  {
    heading: "第16条(準拠法・裁判管轄)",
    paragraphs: [
      "本規約の解釈にあたっては、日本法を準拠法とします。本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。",
    ],
  },
];

const contactInfo = [
  { label: "事業者名", value: "株式会社ナンバ" },
  { label: "代表者", value: "代表取締役 難波 伸敏" },
  { label: "所在地", value: "〒115-0056 東京都北区西が丘2-1-11" },
  { label: "電話番号", value: "03-6454-3314" },
  { label: "メールアドレス", value: "info@namba.ne.jp" },
  { label: "受付時間", value: "平日 9:30〜18:30(土日祝日・年末年始を除く)" },
];

export default function TermsSections() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="space-y-10 rounded-lg border border-background-200 bg-background-50 p-6 font-body text-sm leading-relaxed text-foreground-800 md:p-10">
          {sections.map((section) => (
            <div key={section.heading}>
              <h2 className="mb-4 font-heading text-lg font-bold text-foreground-950">
                {section.heading}
              </h2>
              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph} className="mb-3 last:mb-0">
                  {paragraph}
                </p>
              ))}
              {section.list && (
                <ul className="ml-2 mt-3 list-disc space-y-1.5 pl-4">
                  {section.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          <div>
            <h2 className="mb-4 font-heading text-lg font-bold text-foreground-950">
              第17条(お問い合わせ窓口)
            </h2>
            <p className="mb-4">
              本規約に関するお問い合わせは、以下の窓口までご連絡ください。
            </p>
            <div className="space-y-2 rounded-lg bg-background-100 p-5 text-foreground-700">
              {contactInfo.map((item) => (
                <p key={item.label} className="flex flex-col gap-0.5 sm:flex-row sm:gap-2">
                  <strong className="shrink-0 text-foreground-950 sm:min-w-[7.5rem]">
                    {item.label}:
                  </strong>
                  <span>{item.value}</span>
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}